import { FETCH_USER_PARTICIPATION } from "../types";

export const UserParticipationReducer = (
  state = { isLoading: true, data: [] },
  action
) => {
  switch (action.type) {
    case FETCH_USER_PARTICIPATION:
      return {
        isLoading: false,
        data: action.payload,
        filteredData: action.payload,
      };
    default:
      return state;
  }
};
